import {GET_BUSINESS_HOUR_TEMPLATES,GET_BUSINESS_HOUR_TEMPLATE_DATA} from '../actions/types';

export const fetchTemplatesData = (state = null, action) => {
    switch (action.type) {
        case GET_BUSINESS_HOUR_TEMPLATES:
            return action.payload;
  
        default:
            return state
    }
}
export default fetchTemplatesData;



